import RefData from '../../ref-data';

import experienceStatus from './experience-status';

export default {
  [experienceStatus.ALL]: [
    RefData.Enum.STATUS.CAMPAIGNOBJECT.DRAFT,
    RefData.Enum.STATUS.CAMPAIGNOBJECT.READY,
    RefData.Enum.STATUS.CAMPAIGNOBJECT.SCHEDULED,
    RefData.Enum.STATUS.CAMPAIGNOBJECT.PUBLISHED,
    RefData.Enum.STATUS.CAMPAIGNOBJECT.EXPIRED,
  ].join(','),
  [experienceStatus.DRAFT]:     RefData.Enum.STATUS.CAMPAIGNOBJECT.DRAFT,
  [experienceStatus.READY]:     RefData.Enum.STATUS.CAMPAIGNOBJECT.READY,
  [experienceStatus.SCHEDULED]: RefData.Enum.STATUS.CAMPAIGNOBJECT.SCHEDULED,
  [experienceStatus.PUBLISHED]: RefData.Enum.STATUS.CAMPAIGNOBJECT.PUBLISHED,
  [experienceStatus.EXPIRED]:   RefData.Enum.STATUS.CAMPAIGNOBJECT.EXPIRED,
  [experienceStatus.TEMPLATE]:  RefData.Enum.STATUS.CAMPAIGNOBJECT.TEMPLATE,
};
